import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Server, ShieldCheck, Users, HardDrive, Cloud, ArrowRight, Building2 } from "lucide-react";
import PageHeader from "../components/PageHeader";
import SEO from "../components/SEO";
import { tariefs, siteInfo } from "../mock";
import { useBooking } from "../context/BookingContext";

const Zakelijk = () => {
  const booking = useBooking();
  const services = [
    { icon: Server,      title: "Systeem- en netwerkbeheer", desc: "Wij houden uw servers, werkplekken en netwerk draaiend. Proactief onderhoud, updates en monitoring." },
    { icon: ShieldCheck, title: "Business security",         desc: "Bitdefender GravityZone voor alle werkplekken, e-mail security en awareness-training voor uw team." },
    { icon: HardDrive,   title: "Backup & disaster recovery", desc: "Dagelijkse cloud-backups met snelle restore. Uw data is 24/7 veilig — zelfs bij ransomware." },
    { icon: Cloud,       title: "Microsoft 365 beheer",      desc: "Volledig beheer van uw M365-omgeving: users, licenties, SharePoint en Teams." },
    { icon: Users,       title: "Support voor uw team",      desc: "Uw medewerkers bellen ons rechtstreeks. Wij lossen het op — u werkt door." },
    { icon: Building2,   title: "Verhuizingen & uitbreiding", desc: "Nieuwe locatie? Nieuwe medewerker? Wij regelen de hele IT-inrichting van A tot Z." },
  ];

  return (
    <>
      <SEO
        title="Zakelijk IT-beheer voor MKB & ZZP | Computheer"
        description="Volledig IT-beheer voor uw bedrijf: netwerkbeheer, security, backup en support met vaste maandprijs. Voor MKB en ZZP in de IJmond en omgeving."
      />
      <PageHeader
        eyebrow="Zakelijk"
        title="Uw IT-afdeling — zonder de vaste lasten."
        subtitle="Volledig beheer voor MKB en ZZP: systemen, security en support tegen een vaste maandprijs. Voorspelbaar, betrouwbaar, met korte lijnen."
      />

      <section className="py-20 bg-white">
        <div className="max-w-[1280px] mx-auto px-5 md:px-10">
          <div className="max-w-2xl mb-12">
            <p className="text-sm tracking-[0.3em] uppercase text-neutral-500 mb-3">— Onze zakelijke diensten</p>
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 leading-tight">
              Alles wat u nodig heeft — <span className="italic font-light">zonder</span> eigen IT-afdeling.
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((s) => (
              <div key={s.title} className="border border-neutral-200 p-6 hover:border-neutral-900 hover:shadow-md transition-all">
                <div className="w-12 h-12 rounded-full bg-neutral-100 border border-neutral-200 flex items-center justify-center mb-4">
                  <s.icon size={20} className="text-neutral-900"/>
                </div>
                <h3 className="text-base font-bold text-neutral-900 mb-2">{s.title}</h3>
                <p className="text-sm text-neutral-600 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Zakelijk tarief block */}
      <section className="py-20 bg-neutral-50">
        <div className="max-w-[900px] mx-auto px-5 md:px-10 text-center">
          <p className="text-sm tracking-[0.3em] uppercase text-neutral-500 mb-3">— Zakelijk tarief</p>
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 leading-tight mb-6">
            {tariefs.zakelijk.hourly} <span className="font-light italic text-neutral-500">{tariefs.zakelijk.label}</span>
          </h2>
          <p className="text-neutral-600 mb-8 max-w-lg mx-auto">
            {tariefs.zakelijk.note}. Voor structurele samenwerking kiest u het <strong>IT Support Zakelijk</strong>-abonnement vanaf <strong>€25 per maand</strong> (€250 per jaar).
          </p>
          <ul className="grid sm:grid-cols-2 gap-3 max-w-md mx-auto text-left mb-10">
            {[
              "Vaste maandprijs, geen verrassingen",
              "SLA reactie binnen 4 uur",
              "Backup & security inbegrepen",
              "Kwartaal-onderhoud werkplekken",
            ].map((f) => (
              <li key={f} className="flex items-start gap-2 text-sm text-neutral-800">
                <CheckCircle2 size={17} className="text-emerald-600 shrink-0 mt-0.5"/>
                <span>{f}</span>
              </li>
            ))}
          </ul>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/it-support"
              className="inline-flex items-center justify-center gap-2 bg-neutral-900 hover:bg-black text-white px-7 py-4 text-[15px] font-medium">
              Bekijk zakelijk abonnement
              <ArrowRight size={16}/>
            </Link>
            <button onClick={booking.open}
              className="inline-flex items-center justify-center gap-2 border border-neutral-300 hover:border-neutral-900 text-neutral-900 px-7 py-4 text-[15px] font-medium">
              Vraag vrijblijvend gesprek aan
            </button>
          </div>
          <p className="text-xs text-neutral-500 mt-6">Of bel direct: <a href={`tel:${siteInfo.phoneRaw}`} className="underline">{siteInfo.phone}</a></p>
        </div>
      </section>
    </>
  );
};

export default Zakelijk;
